import { apiPath } from '../../constants';
import { axios, apiRequestOptions, transformHttpResponse } from 'utils';

export const SCHEDULE_PREVIEW_DURATIONS_REQUEST = 'SCHEDULE_PREVIEW_DURATIONS_REQUEST';
export const SCHEDULE_PREVIEW_DURATIONS_SUCCESS = 'SCHEDULE_PREVIEW_DURATIONS_SUCCESS';
export const SCHEDULE_PREVIEW_DURATIONS_FAILURE = 'SCHEDULE_PREVIEW_DURATIONS_FAILURE';

/**
 * Fetches per-category durations from the backend using the same
 * CategoryDurationCalculator that drives schedule generation.
 *
 * @param {string}   competitionId
 * @param {string[]} categoryIds       All category IDs to calculate durations for.
 * @param {Object}   durationSettings  Current (possibly unsaved) settings subset:
 *                                     { categoryDurations, preparationTimeSeconds,
 *                                       teamDurationMultiplier, ageGroupMultipliers }
 */
export const previewDurations = (competitionId, categoryIds, durationSettings) => {
  return function (dispatch) {
    dispatch({ type: SCHEDULE_PREVIEW_DURATIONS_REQUEST });

    return axios(
      apiRequestOptions(apiPath.SCHEDULE.PREVIEW_DURATIONS, {
        competitionId,
        categoryIds,
        settings: durationSettings,
      })
    )
      .then(transformHttpResponse)
      .then(response =>
        dispatch({ type: SCHEDULE_PREVIEW_DURATIONS_SUCCESS, data: response.data.durations })
      )
      .catch(error => transformHttpResponse(error.response))
      .catch(() => {
        dispatch({ type: SCHEDULE_PREVIEW_DURATIONS_FAILURE });
      });
  };
};
